// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__nb8bQ","footerContainer":"footer_footerContainer__bqu9e","github":"footer_github__tMCjv","rss":"footer_rss__z+Zxb","rssYear":"footer_rssYear__d62g8"};